import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { postComanda as addComanda } from "../helpers/rutaComandas";
import { getEmpresas } from "../helpers/rutaEmpresas";
import { getTransportes } from "../helpers/rutaTransportes";
import { getChoferes } from "../helpers/rutaChoferes";
import { getClientes } from "../helpers/rutaClientes";
import { getDestinos } from "../helpers/rutaDestinos";
import { getProductos } from "../helpers/rutaProductos";
import { getCamiones } from "../helpers/rutaCamiones";
import { getEstados } from "../helpers/rutaEstados";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const initialState = {
  codemp: "",
  nroviaje: "",
  fecha: "",
  codtra: "",
  codcho: "",
  codclif: "",
  factura: "",
  estado: "",
  tercero: "",
  codclic: "",
  codori: "",
  coddes: "",
  codclid: "",
  remitos: "",
  codpro: "",
  codcam: "",
  codest: "",
  kgsal: 0,
  kglle: 0,
  dif: 0,
  pactado: 0,
  subtotal: 0,
  porcentaje: "21", // "0" = Sin IVA, "10.5" o "21"
  iva: 0,
  total: 0,
  pactadoter: 0,
  kmsal: 0,
  kmdes: 0,
  observ: "",
};

export default function AddComandaForm({ setShow }) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState(initialState);
  const [lists, setLists] = useState({
    empresas: [], transportes: [], choferes: [],
    clientes: [], destinos: [], productos: [],
    camiones: [], estados: [], loading: true
  });

  useEffect(() => {
    Promise.all([
      getEmpresas(), getTransportes(), getChoferes(),
      getClientes(), getDestinos(), getProductos(),
      getCamiones(), getEstados()
    ]).then(([
      empRes, traRes, choRes, cliRes,
      desRes, prodRes, camRes, estRes
    ]) => {
      setLists({
        empresas: empRes.empresas ?? empRes.data?.empresas ?? [],
        transportes: traRes.transportes ?? traRes.data?.transportes ?? [],
        choferes: choRes.choferes ?? choRes.data?.choferes ?? [],
        clientes: cliRes.clientes ?? cliRes.data?.clientes ?? [],
        destinos: desRes.destinos ?? desRes.data?.destinos ?? [],
        productos: prodRes.productos ?? prodRes.data?.productos ?? [],
        camiones: camRes.camiones ?? camRes.data?.camiones ?? [],
        estados: estRes.estados ?? estRes.data?.estados ?? [],
        loading: false,
      });
    });
  }, []);

  // Recalcular los campos derivados
  useEffect(() => {
    const kgsal    = parseFloat(formValues.kgsal)    || 0;
    const kglle    = parseFloat(formValues.kglle)    || 0;
    const pactado  = parseFloat(formValues.pactado)  || 0;
    const dif      = kgsal - kglle;
    const subtotal = kglle * pactado;
    const porcentajeNum = parseFloat(formValues.porcentaje || "21"); // 0 | 10.5 | 21
    const iva = porcentajeNum === 0 ? 0 : subtotal * (porcentajeNum / 100);
    // const iva      = subtotal * 0.21;
    const total    = subtotal + iva;

    setFormValues(fv => ({
      ...fv,
      dif,
      subtotal,
      iva,
      total
    }));
  }, [formValues.kgsal, formValues.kglle, formValues.pactado, formValues.porcentaje]);

  const handleChange = ({ target: { name, value, type } }) => {
    setFormValues(fv => ({
      ...fv,
      [name]: type === "number" ? parseFloat(value) || 0 : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const usuarioId = localStorage.getItem("usuarioId") || localStorage.getItem("id");

    if (!usuarioId) {
      return alert("Debe iniciar sesión antes de crear una comanda.");
    }

    const payload = {
      ...formValues,
      fecha: moment(formValues.fecha).tz("America/Argentina/Tucuman").toDate(),
      usuario: usuarioId,
    };

    try {
      await addComanda(payload);
      console.log("✅ Comanda creada");

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false);     // Ocultar
        setFormValues(initialState);
        setShow(false);            // Cerrar modal principal
      }, 2000);
    } catch (err) {
      console.error("❌ Error al guardar comanda:", err);
      alert("Error al guardar comanda: " + (err.response?.data?.err || err.message));
    }
  };

  // const handleSubmit = e => {
  //   e.preventDefault();
  //   const usuarioId = localStorage.getItem("usuarioId") || localStorage.getItem("id");
  //   if (!usuarioId) {
  //     return alert("Debe iniciar sesión antes de crear una comanda.");
  //   }
  //   const payload = {
  //     ...formValues,
  //     fecha: moment(formValues.fecha)
  //       .tz("America/Argentina/Tucuman")
  //       .toDate(),
  //     usuario: usuarioId,
  //   };
  //   addComanda(payload)
  //     .then(() => {
  //       setFormValues(initialState);
  //       setShow(false);
  //     })
  //     .catch(err => {
  //       alert("Error al guardar comanda: " + (err.response?.data?.err || err.message));
  //     });
  // };

  if (lists.loading) return <p>Cargando formularios…</p>;

  return (
    <>
    <div className="container mt-4">
      <form onSubmit={handleSubmit}>
        {[
          // Bloque 1: datos generales
          {
            fields: [
              { label: "Empresa", name: "codemp", type: "select", options: lists.empresas },
              { label: "Nro Viaje", name: "nroviaje", type: "text" },
              { label: "Fecha Viaje", name: "fecha", type: "datetime-local" },
              { label: "Transporte", name: "codtra", type: "select", options: lists.transportes },
              { label: "Chofer", name: "codcho", type: "select", options: lists.choferes },
              { label: "Cliente (Factura)", name: "codclif", type: "select", options: lists.clientes },
            ]
          },
          // Bloque 2: facturación y recorrido
          {
            fields: [
              { label: "Factura", name: "factura", type: "text" },
              { label: "Estado", name: "estado", type: "text" },
              { label: "Tercero", name: "tercero", type: "text" },
              { label: "Cliente Carga", name: "codclic", type: "select", options: lists.clientes },
              { label: "Origen", name: "codori", type: "select", options: lists.destinos },
              { label: "Destino", name: "coddes", type: "select", options: lists.destinos },
            ]
          },
          // Bloque 3: descarga y stock
          {
            fields: [
              { label: "Cliente Descarga", name: "codclid", type: "select", options: lists.clientes },
              { label: "Remitos", name: "remitos", type: "text" },
              { label: "Producto", name: "codpro", type: "select", options: lists.productos },
              { label: "Camión", name: "codcam", type: "select", options: lists.camiones },
              { label: "Estado Comanda", name: "codest", type: "select", options: lists.estados },
              { label: "Kg Salida", name: "kgsal", type: "number" },
            ]
          },
          // Bloque 4: cálculos
          {
            fields: [
              { label: "Kg Llegada", name: "kglle", type: "number" },
              { label: "Diferencia", name: "dif", type: "number", readOnly: true },
              { label: "Pactado", name: "pactado", type: "number" },
              { label: "Subtotal", name: "subtotal", type: "number", readOnly: true },
              //porcentaje IVA agregado
              { 
                label: "Porc. IVA", 
                name: "porcentaje", 
                type: "select", 
                col: 1,
                options: [
                  { _id: "0", label: "Sin IVA (0%)" },
                  { _id: "10.5", label: "10,5%" },
                  { _id: "21", label: "21%" },
                ]
              },
              { label: "IVA", name: "iva", type: "number", readOnly: true, col: 1 },
              { label: "Total", name: "total", type: "number", readOnly: true },
            ]
          },
          // Bloque 5: adicionales
          {
            fields: [
              { label: "Pactado Tercero", name: "pactadoter", type: "number" },
              { label: "Km Origen", name: "kmsal", type: "number" },
              { label: "Km Destino", name: "kmdes", type: "number" },
              { label: "Observaciones", name: "observ", type: "text", col: 6 },
            ]
          }
        ].map((row, i) => (
          <div className="form-row" key={i}>
            {row.fields.map(field => (
              <div className={`form-group col-md-${field.col || 2}`} key={field.name}>
                <label>{field.label}</label>
                {field.type === "select" ? (
                  <select
                    name={field.name}
                    className="form-control"
                    value={formValues[field.name]}
                    onChange={handleChange}
                    required={field.required}
                  >
                    <option value="">Seleccione...</option>
                    {field.options.map(o => (
                      <option key={o._id} value={o._id}>
                        {o.label || o.empresa || o.transporte || o.nombre || o.razonsocial || o.destino || o.producto || o.camion || o.estado}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={field.type}
                    name={field.name}
                    className="form-control"
                    value={formValues[field.name]}
                    onChange={handleChange}
                    readOnly={field.readOnly}
                    required={field.required}
                  />
                )}
              </div>
            ))}
          </div>
        ))}
        <button type="submit" className="btn btn-dark mt-3 mb-4">
          Guardar Comanda
        </button>
      </form>
    </div>
    
        <Modal
          show={showSuccess}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="animate__animated animate__fadeInDown"
        >
          <Modal.Body className="text-center">
            <div style={{ fontSize: "3rem" }}>🖐</div>
            <h5 className="mt-2">¡Registro generado correctamente!</h5>
            </Modal.Body>
        </Modal>

  </>
  );
}
